import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { BookingProvider } from './contexts/BookingContext';
import PrivateRoute from './components/auth/PrivateRoute';
import BaseLayout from './routes/layouts/base-layout/BaseLayout';
import Login from './routes/login/Login';
import Search from './routes/search/Search';
import Availability from './routes/availability/Availability';
import Booking from './routes/booking/Booking';
import Confirmation from './routes/confirmation/Confirmation';
import Admin from './routes/admin/Admin';
import Import from './routes/import/Import';
import Calendar from './routes/calendar/Calendar';

const router = createBrowserRouter([
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      { path: '/login', element: <Login /> },
      {
        path: '/',
        element: (
          <PrivateRoute>
            <Search />
          </PrivateRoute>
        ),
      },
      {
        path: '/availability',
        element: (
          <PrivateRoute>
            <Availability />
          </PrivateRoute>
        ),
      },
      {
        path: '/calendar',
        element: (
          <PrivateRoute>
            <Calendar />
          </PrivateRoute>
        ),
      },
      {
        path: '/booking',
        element: (
          <PrivateRoute>
            <Booking />
          </PrivateRoute>
        ),
      },
      {
        path: '/confirmation',
        element: (
          <PrivateRoute>
            <Confirmation />
          </PrivateRoute>
        ),
      },
      {
        path: '/admin',
        element: (
          <PrivateRoute adminOnly>
            <Admin />
          </PrivateRoute>
        ),
      },
      {
        path: '/import',
        element: <Import />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <BookingProvider>
      <RouterProvider router={router} />
    </BookingProvider>
  </AuthProvider>
);
